import Archive from "./Archive/Route";
import Incoming from "./Incoming/Route";
import Outgoing from "./Outgoing/Route";
import Settings from "./Settings/Routes";
import Event from "./Event/Routes";
import Folder from "./Folder/Routes";
import Dashboard from "./Dashboard/Routes";
import Task from "./Task/Routes";
import Reports from "./Reports";
import Speak from "./Speak/Routes";
import Comments from "./Comments/Routes";
import Seal from "./Seal/Routes";

export default [...Archive, ...Incoming, ...Outgoing, ...Settings, ...Event, ...Dashboard, ...Folder, ...Reports, ...Task, ...Speak, ...Comments, ...Seal];
